// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCWR7r8K35Ypmus50hGWdmE5a95onxXryw",
    authDomain: "revista1986-c6922.firebaseapp.com",
    projectId: "revista1986-c6922",
    storageBucket: "revista1986-c6922.appspot.com",
    messagingSenderId: "116455356877",
    appId: "1:116455356877:web:6ca39195f532c8bd14ac84",
    measurementId: "G-W0GW4Z8DRJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export default function getFirestoreApp() {
    return app
}


